import {SizeCharts_SizeSystem} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_charts.types';
import {usePrevious} from '@aboutyou/utils';
import {useMemo} from 'react';

export const useSelectedSizeSystem = (
  selectedOption: number,
  sizeSystems: Array<SizeCharts_SizeSystem>,
) => {
  const selectedSizeSystem = useMemo(() => {
    return sizeSystems[selectedOption];
  }, [sizeSystems, selectedOption]);

  const lastSelectedSizeSystem = usePrevious(
    selectedSizeSystem,
    (_, currentValue) => {
      return !!currentValue;
    },
  );
  return selectedSizeSystem || lastSelectedSizeSystem;
};
